import React, { useState } from "react";
import { Avatar, Button, Card, Col, Descriptions, Row, Space } from "antd";
import { ReactComponent as CalenderSvg } from "../../../../assets/images/description/calendar.svg";
import { ReactComponent as DeleteSvg } from "../../../../assets/images/action/deleteWhite.svg";
import { ReactComponent as PersonSvg } from "../../../../assets/images/description/person.svg";
import { ReactComponent as AboutSvg } from "../../../../assets/images/description/Notes.svg";
import { ReactComponent as VideoSvg } from "../../../../assets/images/description/Videos.svg";
import { UserOutlined } from "@ant-design/icons";

import { useNavigate } from "react-router";

// Breakpoints
const descriptions_breakpoint = {
  xxl: 4,
  xl: 4,
  lg: 3,
  md: 3,
  sm: 2,
  xs: 1,
};
const ViewAuthorDetails = () => {
  const navigate = useNavigate();

  const data = [];
  const basicInfo_details = [
    {
      key: "1",
      label: (
        <>
          <PersonSvg /> Author Name
        </>
      ),
      children: data?.basicInfo?.[0]?.name ?? "user",
    },
    {
      key: "2",
      label: (
        <>
          <CalenderSvg /> Date Added
        </>
      ),
      children: data?.basicInfo?.[0]?.name ?? "user",
    },
    {
      key: "3",
      label: (
        <>
          <VideoSvg /> Total Videos
        </>
      ),
      children: data?.basicInfo?.[0]?.name ?? "user",
    },
    {
      key: "4",
      label: (
        <>
          <AboutSvg /> About the author
        </>
      ),
      children: data?.basicInfo?.[0]?.name ?? "user",
    },
  ];
  return (
    <>
      <div className="viewTenant">
        <div className="tableHeading">View Author Details</div>
        <Space>
          <Button
            type="danger"
            onClick={() => navigate(-1)}
            icon={<DeleteSvg />}
            className="delete"
          >
            Delete
          </Button>
          <Button type="primary" onClick={() => navigate(-1)}>
            Edit Details
          </Button>
        </Space>
      </div>
      <Card>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={18}>
            <div className="customDescription">
              <Descriptions
                className="custom_descriptions"
                layout="vertical"
                items={basicInfo_details}
                size="small"
                column={{ xs: 1, sm: 2, md: 3 }}
              />
            </div>
          </Col>

          {/* Right Column (50%) - Podcast Image */}
          <Col xs={24} md={6} className="podcast-image-container">
            <Avatar
              size={120}
              icon={<UserOutlined />}
              alt="User Img"
              style={{
                backgroundColor: "#45AE51",
                color: "#fff",
                border: "2px solid #fff",
                boxShadow: "0px 1px 2px rgba(0,0,0,0.2)",
              }}
            />
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default ViewAuthorDetails;
